import React from 'react';

import { navigate } from '@reach/router';
import { isMobile } from 'react-device-detect';
import LeftArrow from '@material-ui/icons/ChevronLeftRounded';
import RightArrow from '@material-ui/icons/ChevronRightRounded';

import Button from '../../../../../components/Button';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';
import useLocation from '../../../../../contrib/Hooks/useLocation.hook';
import { useGetAdminEvent } from '../../../../../contrib/Hooks/useGetAdminEvent';

interface IEventWizardStepTitle {
  buttonDisabled?: boolean;
  buttonOnClick?: any;
  buttonText?: string;
  title: string;
  tooltip?: JSX.Element;
}

type TButtonType = 'button' | 'submit' | 'reset' | undefined;

export const EventWizardStepTitle = (props: IEventWizardStepTitle) => {
  const { buttonDisabled, buttonOnClick: onClick, buttonText, title, tooltip } = props;

  const { clubId, eventId, roundId } = useRouteInfoState();
  const {
    location: { pathname }
  } = useLocation();

  const buttonProps = onClick
    ? { onClick, type: 'button' as TButtonType }
    : { type: 'submit' as TButtonType };

  const event = useGetAdminEvent(eventId);

  const goToPrevious = () => {
    const eventWizardSteps = [
      `/staff/club/${clubId}/events`,
      `/staff/club/${clubId}/event/${eventId}/setup/start`,
      `/staff/club/${clubId}/event/${eventId}/setup/basic`,
      `/staff/club/${clubId}/event/${eventId}/setup/formats`,
      `/staff/club/${clubId}/event/${eventId}/setup/rounds`,
      // Temporarily disable fees screen due to https://code.talpor.com/club15/frontend/-/issues/900
      // `/staff/club/${clubId}/event/${eventId}/setup/fees`,
      `/staff/club/${clubId}/event/${eventId}/setup/publish`,
      `/staff/club/${clubId}/event/${eventId}/setup/players`,
      `/staff/club/${clubId}/event/${eventId}/setup/start`,
      `/staff/club/${clubId}/event/${eventId}/round/${roundId}/setup`,
      `/staff/club/${clubId}/event/${eventId}/round/${roundId}/teams`,
      `/staff/club/${clubId}/event/${eventId}/round/${roundId}/teesheet`,
      `/staff/club/${clubId}/event/${eventId}/round/${roundId}/contest`,
      event && event.flights.length > 1
        ? `/staff/club/${clubId}/event/${eventId}/round/${roundId}/flights`
        : null,
      `/staff/club/${clubId}/event/${eventId}/round/${roundId}/launch`,
      `/staff/club/${clubId}/event/${eventId}/round/${roundId}/results`,
      `/staff/club/${clubId}/event/${eventId}/round/${roundId}/awards`,
      `/staff/club/${clubId}/event/${eventId}/round/${roundId}/complete`,
      `/staff/club/${clubId}/event/${eventId}/setup/start`,
      `/staff/club/${clubId}/event/${eventId}/complete`
    ].filter(Boolean) as string[];

    const currentRouteIndex = eventWizardSteps.findIndex(step => step === pathname);

    navigate(eventWizardSteps[currentRouteIndex > 0 ? currentRouteIndex - 1 : 0]);
  };

  return (
    <div className={`event-wizard-title ${!isMobile ? 'sticky' : 'mobile'}`}>
      <h2>
        {title}
        {tooltip}
      </h2>

      <div className="nav-buttons">
        {isMobile && (
          <Button
            color="primary"
            className="all-events-button override"
            variant="text"
            id="create-event-submit"
            type="button"
            onClick={goToPrevious}
          >
            <LeftArrow className="right-arrow-icon" />
            GO TO PREVIOUS
          </Button>
        )}

        <Button
          color="primary"
          className="continue-button"
          variant={buttonDisabled ? 'contained' : 'text'}
          id="create-event-submit"
          {...buttonProps}
          disabled={buttonDisabled}
        >
          {buttonText ? buttonText : 'SAVE & CONTINUE'}
          <RightArrow className="right-arrow-icon" />
        </Button>
      </div>
    </div>
  );
};
